import { render, staticRenderFns } from "./DetailLowMovingStock.vue?vue&type=template&id=e7e74726&scoped=true&"
import script from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
export * from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailLowMovingStock.vue?vue&type=style&index=0&id=e7e74726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e74726",
  null
  
)

export default component.exports